import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import API from 'app/api';

const constructUrl = (projectId, observationId = '') =>
    `/project/${projectId}/observation${observationId ? `/${observationId}` : ''}`;

export const createObservation = createAsyncThunk('observation/create', async ({ projectId, observation }, { dispatch }) => {
    const { data } = await API.post(constructUrl(projectId), observation);
    dispatch(getAllObservations({ projectId }));
    return data;
});

export const updateObservation = createAsyncThunk('observation/update', async ({ projectId, id, observation }, { dispatch }) => {
    const { data } = await API.put(constructUrl(projectId, id), observation);
    dispatch(getAllObservations({ projectId }));
    return data;
});

export const getAllObservations = createAsyncThunk('observation/getAll', async ({ projectId }) => {
    const { data } = await API.get(constructUrl(projectId));
    return data;
});

export const getObservationById = createAsyncThunk('observation/getById', async ({ projectId, id }) => {
    const { data } = await API.get(constructUrl(projectId, id));
    return data;
});

export const batchDeleteObservations = createAsyncThunk('observation/batchDelete', async ({ projectId, arrayOfObvIds }) => {
    const { data } = await API.delete(constructUrl(projectId), { data: { observationIds: arrayOfObvIds } });
    return data;
});

export const exportObservations = createAsyncThunk('observation/export', async ({ projectId }) => {
    const { data } = await API.post(`${constructUrl(projectId)}/export`);
    return data;
});

const observationSlice = createSlice({
    name: 'observation',
    initialState: {
        observations: {},
        loading: false,
        error: null,
        export: null,
    },
    reducers: {
        clearObservations: () => observationSlice.getInitialState(),
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllObservations.pending, (state) => { state.loading = true; state.error = null; })
            .addCase(getAllObservations.fulfilled, (state, action) => {
                state.loading = false;
                state.observations = action.payload.reduce((acc, obs) => {
                    acc[obs.Id ?? obs.id] = obs;
                    return acc;
                }, {});
            })
            .addCase(getAllObservations.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
            .addCase(createObservation.fulfilled, () => {})
            .addCase(updateObservation.fulfilled, () => {})
            .addCase(batchDeleteObservations.fulfilled, (state, action) => {
                if (action.payload?.results) {
                    action.payload.results.forEach((r) => {
                        const id = r.ObservationId ?? r.observationId;
                        if (r.Status === 'Deleted' || r.status === 'Deleted') delete state.observations[id];
                    });
                }
            })
            .addCase(exportObservations.fulfilled, (state, action) => {
                state.export = action.payload;
            });
    },
});

export const { clearObservations } = observationSlice.actions;
export default observationSlice.reducer;
